var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScalesJustice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.67 61.16 72.11 118.03 30.35 118.03 52.67 61.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "167.87 40.99 146.99 95 187.31 95 167.87 40.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.39,
    y1: 60.43,
    x2: 167.15,
    y2: 39.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.83,
    y1: 30.91,
    x2: 110.27,
    y2: 131.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "87.95 156.19 87.95 132.44 131.15 132.44 131.15 159.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,188.59h151.2s0-22.32-24.48-28.08H56.27S36.11,166.27,34,188.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalesJustice);
export default __webpack_public_path__ + "static/media/SCALES_JUSTICE.d2695cd6ccd182623a607aab6173011a.svg";
export { ForwardRef as ReactComponent };